export const SUBMIT_REVIEW_BUTTON_TEXT = 'Submit a Review';
export const NO_SEARCH_RESULTS = 'No Results found';
export const NO_RESULTS_TEXT = 'Sorry, There are no reviews available for this vehicle'; // @suppress longLineCheck
